import React from 'react'

import { FormControl } from '@twilio-paste/core/form'
import { Select, Option } from '@twilio-paste/core/select'

const Dropdown = ({ curInteractives, sendMessage }) => {
  return (
    <FormControl>
      <Select
        id='select'
        defaultValue={''}
        onChange={(e) => sendMessage(e.target.value)}
      >
        {curInteractives.options.map((o, idx) => (
          <Option key={o.uuid} value={o.value}>
            {o.content}
          </Option>
        ))}
      </Select>
    </FormControl>
  )
}

export default Dropdown
